import React, { Component } from 'react'
import styled from 'styled-components'

import PropTypes from 'prop-types'

import { below } from '../style/functions';

const windowGlobal = typeof window !== "undefined" && window

class ParallaxImage extends Component {
  constructor() {
    super();

    // Element ref
    this.parallaxRef = React.createRef();

    // State
    this.state = {
      top: 0
    };

    this.scroll = this.scroll.bind(this)
    this.queueScroll = this.queueScroll.bind(this)
  }

  scroll() {
    let el = this.parallaxRef.current;
    this.queued = null


    if( el && el.getBoundingClientRect ) {
      const { top: imageTop, height: imageHeight } = el.getBoundingClientRect()

      // Run if in view
      if( imageTop > this.height || imageTop < -imageHeight) 
        return

      // Move progress from 0 to 1;
      // where 0 is when the imageTop is at the top of the screen 
      // and 1 when the bottom of the image is at the bottom of the screen
      const distance = this.height - imageHeight
      if( distance < 50 ) 
        this.setState({ top: "-8rem" });

      else {
        const progress = imageTop / distance
        this.setState({ top: (progress * -8).toFixed(2) + "rem" });
      }
    }
  }

  componentDidMount() {
    if( windowGlobal ) {
      windowGlobal.addEventListener("scroll", this.queueScroll)
      this.height = windowGlobal.innerHeight
    }
  }

  componentWillUnmount() {
    if( windowGlobal ) {
      windowGlobal.removeEventListener("scroll", this.queueScroll)
      windowGlobal.cancelAnimationFrame(this.queued)
    }
  }

  queueScroll() {
    if( !this.queued )
      this.queued = windowGlobal.requestAnimationFrame(this.scroll)
  }

  render() {
    const { src } = this.props;

    return (
      <ParallaxImageWrapper innerRef={this.parallaxRef}>
        <ParallaxImageEl distance={this.distance} src={src} style={{transform: `translateY(${this.state.top})`}}></ParallaxImageEl>
      </ParallaxImageWrapper>
    );
  }
}


const ParallaxImageWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  overflow: hidden;
`

const ParallaxImageEl = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: -8em;

  ${below.mobile`
    transform: none !important;
    margin-bottom: 0;
  `}
`

//@NOTE: please adhere to these propTypes
ParallaxImage.propTypes = {
  src: PropTypes.string,
}

export default ParallaxImage
